export default "__VITE_ASSET__a74c2870__"